import { gql } from '@apollo/client';

export const loadUserClaims = gql`
  query loadUserClaims {
    loadUserClaims {
      id
      name
    }
  }
`;
